import React, {useCallback, useContext, useEffect, useState} from 'react';
import Button from '../common/components/Button';
import NoContent from '../common/components/NoContent';
import NoCategoryIcon from '../../assests/img/no-role.svg?react';
import {getDataApi, getUserByRoleIdApi} from '../common/api/getApiData';
import Loader from '../common/components/Loader';
import Select, {MenuProps, components} from 'react-select';
import ManageContentLayout from '../manage-users/ManageContentLayout';
import AddIcon from '../../assests/img/primary-add-icon.svg?url';
import '../../assests/css/userrole.scss';
import AddRolePopup, {newRoleType} from './AddRolePopup';
import Permission from './Permission';
import {DEFINED_ROLES, SELECT_PLACEHOLDER} from '../../constants/permission';
import {addNewUserRoleApi} from '../common/api/postApi';
import {toast} from 'react-toastify';
import RenameRolePopup from './RenameRolePopup';
import DeleteRolePopup from './DeleteRolePopup';
import {deleteDataApi} from '../common/api/deleteApi';
import {updateDataApi} from '../common/api/updateApi';
import CustomDropdownIndicator from '../common/components/CustomDropdownIndicator';
import {AuthCodeMSALBrowserAuthenticationProvider} from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser'; 
import {AuthContext} from '../common/context/authContext';
import {msalInstance} from '../..';
import {Client, BatchRequestStep, BatchRequestContent} from '@microsoft/microsoft-graph-client';
import {InteractionType} from '@azure/msal-browser';
import _ from 'lodash';


interface userRoleType {
    userRoleId: string,
    userRoleName: string,
    permission: string,
    createdOn: string,
    updatedOn: string,
    createdBy: string,
    uodatedBy: string,
    noOfUsers: number,
    permissions: string[],
    permissionToUpdate: string,
}

type buttonIdType = 'Rename' | 'Delete' | 'Add' | 'None';

function RoleContent() {
    const [
        userRoles,
        setUserRoles,
    ] = useState<userRoleType[]>([
    ]);
    const [
        selectedRole,
        setSelectedRole,
    ] = useState<userRoleType>({
        userRoleId: SELECT_PLACEHOLDER,
        userRoleName: SELECT_PLACEHOLDER,
        permission: '',
        createdBy: '',
        uodatedBy: '',
        createdOn: '',
        updatedOn: '',
        noOfUsers: 0,
        permissions: [
        ],
        permissionToUpdate: '',
    });
    const [
        showPopup,
        setShowPopup,
    ] = useState<boolean>(false);
    const [
        buttonId,
        setButtonId,
    ] = useState<buttonIdType>('None');
    const [
        loading,
        setLoading,
    ] = useState<boolean>(true);
    const [
        users,
        setUsers,
    ] = useState<{
        id: string, email: string, azureUserId: string,
        firstName: string, lastName: string}[]>([]);

    const {accounts} = useContext(AuthContext);

    const getUserRoles = useCallback(async () => {
        const roles = await getDataApi('GetUserRole', accounts);
        setUserRoles(roles.map((role: any) => {
            return {...role, userRoleId: role.userRoleId.toString(),
                permissions: [...DEFINED_ROLES[role.permission].permissions],
                permissionToUpdate: role.permission};
        }));
        setLoading(false);
    }, [
    ]);

    useEffect(() => {
        getUserRoles();
    }, [
        getUserRoles,
    ]);

    const getGraphClient = () => {
        const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
            msalInstance, {
            account: accounts[0],
            interactionType: InteractionType.Popup,
            scopes: ['User.Read'],
        });
        const options = {
            authProvider: authProvider,
        }
        const graphClient = Client.initWithMiddleware(options);

        return graphClient;
    };

    const getUserGroupId = (userRoleId: string) => {
        const userRole = userRoles.filter((role) => {
            return role.userRoleId === userRoleId;
        })[0];

        if (!userRole) {
            toast.error('User group cannot be found');
            return '';
        }

        const userGroupId = DEFINED_ROLES[userRole.permission].groupId;

        return userGroupId;
    };

    const moveUserFromAzureUserGroup = async (
        newUserGroupId: string, oldUserGroupId: string, graphClient: Client,
    ) => {
        // Create batch
        const allowedBatchSize = 20;
        const batch = [];
        if (users.length > allowedBatchSize) {
            for (let i=0; i<users.length; i+=allowedBatchSize) {
                const chunk = users.slice(i, i+allowedBatchSize);
                if (chunk.length) {
                    batch.push(chunk);
                }
            }
        } else {
            batch.push(users);
        }

        // Assign to security group
        for (let a=0; a<batch.length; a++) {
            const addBatchRequestStep = batch[a].map((user) => {
                return {
                    id: `add-member_${newUserGroupId}_${user.azureUserId}`,
                    request: new Request(
                        `/groups/${newUserGroupId}/members/$ref`,
                        {
                            method: 'POST',
                            body: JSON.stringify({
                                '@odata.id': `https://graph.microsoft.com/v1.0/users/${user.azureUserId}`,
                                '@odata.userPrincipalName': `${user.email}`,
                                '@odata.displayName': `${user.firstName} ${user.lastName}`,
                                '@odata.givenName': `${user.firstName}`,
                                '@odata.surname': `${user.lastName}`
                            }),
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        }
                    )
                } as BatchRequestStep
            });

            const batchRequestContent = new BatchRequestContent(
                addBatchRequestStep,
            );
            const content = await batchRequestContent.getContent();
            await graphClient.api('/$batch').post(content);
        }

        // Remove user from security group
        for (let b=0; b<batch.length; b++){
            const removeBatchRequestStep = batch[b].map((user) => {
                return {
                    id: `remove-member_${oldUserGroupId}_${user.azureUserId}`,
                    request: new Request(
                        `/groups/${oldUserGroupId}/members/${user.azureUserId}/$ref`,
                        {
                            method: 'DELETE',
                        }
                    )
                } as BatchRequestStep
            });

            const batchRequestContent = new BatchRequestContent(
                removeBatchRequestStep,
            );
            const content = await batchRequestContent.getContent();
            await graphClient.api('/$batch').post(content);
        }
    };

    const getUserByRoleId = useCallback(async () => {
        if (selectedRole.noOfUsers) {
            const {res, error} = await getUserByRoleIdApi(
                selectedRole.userRoleId, accounts);
            if (!error) {
                setUsers(res.value);
            }
        }
    }, [
        selectedRole.noOfUsers,
    ]);

    useEffect(() => {
        getUserByRoleId();
    }, [
        getUserByRoleId,
    ]);

    const getUserRolesMaster = (): {value: string, label: string} [] => {
        return userRoles.map((role) => {
            return {value: role.userRoleId.toString(),
                label: role.userRoleName};
        });
    };

    const getInitialUserRole = ():userRoleType => {
        return {
            userRoleId: SELECT_PLACEHOLDER,
            userRoleName: SELECT_PLACEHOLDER,
            permission: '',
            createdBy: '',
            uodatedBy: '',
            createdOn: '',
            updatedOn: '',
            noOfUsers: 0,
            permissions: [
            ],
            permissionToUpdate: '',
        };
    };

    const getSelectedRole = (userRoleId: string) => {
        const role = userRoles.filter((role) => {
            return role.userRoleId.toString() === userRoleId.toString();
        })[0];
        return role ? role : getInitialUserRole();
    };

    const handleRoleSelect = (role: any) => {
        const roleMatched = getSelectedRole(role.value);
        setSelectedRole(roleMatched);
    };

    const handleAddRole = async (newRole: newRoleType) => {
        try {
            await addNewUserRoleApi(newRole, accounts);
            toast.success('Role created successfully');
            getUserRoles();
            setShowPopup(false);
        } catch (e: any) {
            toast.error(e.data.error.message);
        }
    };

    const handleRenameRole = async (value: string) => {
        setSelectedRole((prevState) => {
            return {...prevState, userRoleName: value};
        });
        await updateDataApi(`UserRole/userRoleId/${selectedRole.userRoleId}`, {userRoleName: value}, accounts);
        toast.success('Role renamed successfully');
        getUserRoles();
        setShowPopup(false);
    };

    const handleDeleteRole = async (move?: {oldId: string, newId: string}) => {
        if (move) {
            try {
                const graphClient = getGraphClient();
                const newUserGroupId = getUserGroupId(move.newId);
                const oldUserGroupId = getUserGroupId(move.oldId);
                
                await moveUserFromAzureUserGroup(
                    newUserGroupId, oldUserGroupId, graphClient);
    
                const res = await updateDataApi(
                    `MoveUserRole`, {oldRoleId: move.oldId, newRoleId: move.newId},
                    accounts);
                if (res === 200) {
                    toast.success('Role deleted successfully');
                    getUserRoles();
                    setShowPopup(false);
                    setSelectedRole(getInitialUserRole());
                }
            } catch (error: any) {
                toast.error(JSON.parse(error.body).message);
            }
        } else {
            const res = await deleteDataApi(`UserRole/userRoleId/${selectedRole.userRoleId}`,
                accounts);
            if (res === 204) {
                toast.success('Role deleted successfully');
                getUserRoles();
                setShowPopup(false);
                setSelectedRole(getInitialUserRole());
            }
        }
    }

    const handleSubmitChange = async () => {
        await updateDataApi(`UserRole/userRoleId/${selectedRole.userRoleId}`, {permission: selectedRole.permissionToUpdate}, accounts);
        toast.success('Permission updated successfully');
        setSelectedRole((prevState) => {
            return {...prevState, permission: prevState.permissionToUpdate};
        });
        getUserRoles();
    };

    const handlePermissionChange = (checked: boolean, permission: string) => {
        let currentPermissions = [
            ...selectedRole.permissions,
        ];
        if (checked) {
            currentPermissions.push(permission);
        } else {
            currentPermissions = currentPermissions.filter(
                (perm) => perm !== permission);
        }
        currentPermissions.sort();
        let permissionShortName = 'R'
        Object.keys(DEFINED_ROLES).forEach((role) => {
            const roles = [
                ...DEFINED_ROLES[role].permissions,
            ].sort();
            if (_.isEqual(roles, currentPermissions)) {
                permissionShortName = role;
            }
        });

        setSelectedRole((prevState) => {
            return {
                ...prevState,
                permissionToUpdate: permissionShortName,
                permissions: currentPermissions,
            };
        });
    }

    const handleCtaOnClick = (buttonId: buttonIdType, show: boolean) => {
        setButtonId(show ? buttonId : 'None');
        setShowPopup(show);
    };

    const CustomSelect = (
        props: MenuProps<{value: string, label: string}>,
    ) =>  (
        <>
            <components.Menu {...props}>
                <div className='input-select-cta'>
                    <Button type='secondary' buttonText='Add New Role'
                        onClick={() => handleCtaOnClick('Add', true)} 
                        buttonIconUrl={AddIcon}/>
                </div>
                {props.children}
            </components.Menu>
        </>
    );

    const renderBottomContent = () => {
       const role = getSelectedRole(selectedRole.userRoleId);
       const selectedPermission = role.permissionToUpdate ?
       DEFINED_ROLES[role.permissionToUpdate].permissions : null;
       
       return selectedPermission ? (
            <Permission
                selectedPermission={selectedPermission}
                userRoleId={selectedRole.userRoleId}
                disableCheck={selectedRole.permission.includes('A')}
                onClick={handlePermissionChange}/>
        ):  <NoContent
            textToDisplay='Select role from top dropdown to see permissions.' 
            cta={<></>}
            mainImage={<></>}                         
            customClassName='user-permission-content-cotainer'/>;
    };

    const renderPopup = () => {
        switch (buttonId) {
            case 'Delete':
                return (<DeleteRolePopup
                    showPopup={showPopup}
                    noOfuser={selectedRole.noOfUsers}
                    roleName={selectedRole.userRoleName}
                    roleId={selectedRole.userRoleId}
                    roleList={getUserRolesMaster()}
                    onClose={(show) => handleCtaOnClick('Delete', show)}
                    onDelete={handleDeleteRole}
                />);
            case 'Rename':
                return (<RenameRolePopup
                    showPopup={showPopup}
                    handleClose={(show) => handleCtaOnClick('Rename', show)}
                    handleRename={handleRenameRole}
                    userRoleName={selectedRole.userRoleName}/>);
            case 'Add':
                return (<AddRolePopup
                    showPopup={showPopup}
                    setShowPopup={(show) => handleCtaOnClick('Add', show)}
                    addRole={handleAddRole}/>);
            default:
                return <></>;
        }
    };

    return (
        <>
            {renderPopup()}
            {!loading ?
                userRoles.length ?
                <ManageContentLayout
                    header='Manage Role'
                    showHeaderCta={false}
                    ctaConfig={{
                        primaryCtaText: 'Submit Changes',
                        primaryCtaOnClick: () => handleSubmitChange(),
                        primaryCtaDisable: selectedRole.permission === 
                        selectedRole.permissionToUpdate,
                        secondaryCta1Text: 'Rename Role',
                        secondaryCta1OnClick: () => selectedRole.userRoleId !== SELECT_PLACEHOLDER ? handleCtaOnClick('Rename', true) : null,
                        secondaryCta2Text: 'Delete Role',
                        secondaryCta2OnClick: () => selectedRole.userRoleId !== SELECT_PLACEHOLDER ? handleCtaOnClick('Delete', true) : null,
                        secondaryCta1Disable: selectedRole.permission.includes('A'),
                        secondaryCta2Disable: selectedRole.permission.includes('A'),
                    }}
                    topContent={<Select
                        options={getUserRolesMaster()}
                        defaultValue={{value: selectedRole.userRoleId,
                            label: selectedRole.userRoleName}}
                        value={{value: selectedRole.userRoleId,
                            label: selectedRole.userRoleName}}
                        placeholder={'Select Role'}
                        isSearchable
                        name='user-role-select'
                        onChange={handleRoleSelect}
                        className='input-select'
                        components={{
                            Menu: CustomSelect,
                            DropdownIndicator: CustomDropdownIndicator,
                        }}
                        styles={{
                            indicatorSeparator: (base) => ({
                                ...base,
                                display: 'none',
                            }),
                        }}
                    />}
                    bottomContentHeader='Permissions'
                    bottomContent={renderBottomContent()}
                    headerCtaOnClick={() => false}
                /> :
                    <NoContent
                        textToDisplay={'You don’t have any roles added. Create your first role!'}
                        cta={<Button buttonText='Create Role' type='primary' onClick={() => handleCtaOnClick('Add', true)}/>}
                        mainImage={<NoCategoryIcon width={"185"} height={"141"}
                        />}
                    />
            : <Loader/>}
        </>
    );

}

export default RoleContent;
